import { qweIsEmpty } from "../../common/commonHelper";
import { FilterInputRule, FilterMultSelectRule, FilterBetweenRule } from "./index"

export default{
    props:{
        filterItem:{
            type:Object
        },
        contentDefinition:{
            type:Object
        }
    },
    inject:["contentType", "buildFormContext"],

    created:function(){
        let self = this;
        this.$watch("contentDefinition.Name",function(newValue,oldValue){
            if(qweIsEmpty(newValue)){
                return;
            }
            self.initFilterConfig();
        });
    },

    computed:{
        showInput:function(){
            return FilterInputRule.includes(this.filterItem.operator);
        },
        showMultSelect:function(){
            return FilterMultSelectRule.includes(this.filterItem.operator);
        },
        showBetween:function(){
            return FilterBetweenRule.includes(this.filterItem.operator);
        }
    },

    methods:{
        initFilterConfig:function(){

        }
    }
}